import {getWindow} from 'ssr-window';
import EnvironmentUtils from '@spothero/utils/environment';

const window = getWindow();

export const getFOVFromLatLngBounds = bounds => {
    if (
        EnvironmentUtils.isBrowser() &&
        !(bounds && bounds instanceof window.google.maps.LatLngBounds)
    ) {
        throw new Error(
            'A valid google maps LatLngBounds object is required for bounds.'
        );
    }

    const boundsNE = bounds.getNorthEast();
    const boundsSW = bounds.getSouthWest();

    /* eslint-disable camelcase */
    return {
        fov_min_lat: boundsNE.lat(),
        fov_min_lng: boundsNE.lng(),
        fov_max_lat: boundsSW.lat(),
        fov_max_lng: boundsSW.lng(),
    };
    /* eslint-enable camelcase */
};
